import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'base-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class TagComponent {

  readonly tagInput = input<string>('');
  readonly indexInput = input<number>(0);

  get tag() { return this.tagInput(); }
  get index() { return this.indexInput() % 4; }

  readonly tagLabel = computed(() => this.tagInput() || '');
  readonly tagIndex = computed(() => this.indexInput() % 4);
  readonly tagClasses = computed(() => ({
    'button-style-1': this.tagIndex() === 0,
    'button-style-2': this.tagIndex() === 1,
    'button-style-3': this.tagIndex() === 2,
    'button-style-4': this.tagIndex() === 3
  }));

}


